export default __webpack_public_path__ + "static/home-banner-efe0838f17017a371475e7e548f6f96f.mp4";